/**
 * DB + Sequelize use start_day / end_day (model: startDay, endDay). Some responses may
 * expose snake_case; admin forms use startDayOffset / endDayOffset as labels only.
 */

export function readPackageDayOffsets(pkg) {
  if (!pkg || typeof pkg !== 'object') return { start: 0, end: 0 };
  const startRaw =
    pkg.startDayOffset ??
    pkg.startDay ??
    pkg.start_day;
  const endRaw =
    pkg.endDayOffset ??
    pkg.endDay ??
    pkg.end_day;
  const start =
    startRaw === null || startRaw === undefined || startRaw === ''
      ? 0
      : Number(startRaw);
  const end =
    endRaw === null || endRaw === undefined || endRaw === ''
      ? 0
      : Number(endRaw);
  return {
    start: Number.isFinite(start) ? start : 0,
    end: Number.isFinite(end) ? end : 0
  };
}

/** Integer day for API (allows negative offsets, zero). */
export function parseDayOffsetField(value) {
  if (value === '' || value === null || value === undefined) return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function packageDayPayloadFromForm(form) {
  const start = parseDayOffsetField(form.startDayOffset);
  const end = parseDayOffsetField(form.endDayOffset);
  return {
    startDay: start,
    endDay: end
  };
}
